import { BaseMainHeaderMenu } from './main-header-menu';
import { MenuItem } from './menu-item';
import { MenuMode } from './menu-mode.enum';
import { MenuStates } from './menu-states.enum';

export class SettingMainHeaderMenu extends BaseMainHeaderMenu {
    constructor(state: MenuStates, opts?: { items: MenuItem[] }) {
        super(MenuMode.SETTINGS, state, { title: '', items: opts?.items ?? [] });
    }
}
